// Mock data for Khesed+ Avad Ministry Website

export const ministryInfo = {
  name: "Khesed+ Avad",
  tagline: "Repairing the breach and restoring lives on the Truth",
  mission: "We exist to repair the breach where lies and brokenness have taken root, and restore lives on the foundation of Truth. We want to equip people to experience healing, freedom, and transformation.",
  description: "Khesed+ 'Avad is a ministry dedicated to helping others rebuild their lives on a firm foundation- Jesus Christ. Whether you are in a season of healing, growth, or searching for peace, you are not alone. Let's live in a way that preserves God's truth while adding spiritual \"flavor\" to the world, and draw others to Jesus through your life. We're here to walk with you. We stand in the gap, bringing healing, restoration, and God's truth where things have been broken.",
  contact: {
    email: "Khesed.love.mercy@gmail.com"
  },
  socialMedia: {
    tiktok: "angelica.Khesed",
    instagram: "Smilez_21"
  }
};

export const services = [
  {
    id: 1,
    title: "1:1 Personal Coaching Sessions",
    description: "Personal faith based coaching designed to help you overcome negative thinking, strengthen your walk with Christ, and find peace in life's challenges. Your first session is completely FREE--Let's discover if we're the right fit for your growth journey.",
    features: [
      "First session completely FREE",
      "Faith-based approach to life coaching", 
      "Overcome negative thinking patterns",
      "Strengthen your walk with Christ",
      "Find peace in life's challenges",
      "Monthly packages available"
    ],
    pricing: {
      firstSession: "First session: FREE",
      ongoing: "Additional sessions: $35 each",
      package: "Monthly package: $100 (4 sessions)"
    },
    format: "In-person or virtual sessions",
    highlight: "First Session FREE"
  },
  {
    id: 2,
    title: "12-Week Transformation Program", 
    description: "A 12 week faith-based journey to renew your mind, heal past wounds, and walk boldly in your God given identity. This program includes our Faith-Based CBT workbook and personalized coaching to help you replace lies with Truth and lasting transformation. We want to catch those negative thoughts, challenge them, and change them with the Word of God.",
    features: [
      "Faith-based CBT workbook included",
      "12 weeks of structured content",
      "Scripture-based foundation",
      "Freedom from lies and brokenness", 
      "Self-paced learning",
      "Physical workbook (beautifully designed)"
    ],
    pricing: {
      standalone: "Workbook only: $30 (physical copy)",
      withCoaching: "FREE when you choose life coaching",
      comingSoon: "Full program launching soon"
    },
    format: "Physical workbook (digital coming soon)",
    highlight: "FREE with Coaching"
  },
  {
    id: 3,
    title: "Prayer Ministry",
    description: "Our prayer ministry is here for you. Share your request with us, and we will personally lift you up in prayer, standing in agreement with you during any of life's seasons. Always confidential, always free.",
    features: [
      "Personal prayer call",
      "Confidential and caring",
      "Standing in agreement together",
      "No request too big or small",
      "Prompt response to urgent needs"
    ],
    pricing: "Always FREE",
    delivery: "Submit request + receive prayer call",
    highlight: "Always Available"
  },
  {
    id: 4,
    title: "Daily Devotionals",
    description: "Daily encouragement and biblical wisdom to strengthen your faith journey. Each devotional is crafted to bring hope, healing, and spiritual growth to your everyday life.",
    features: [
      "Daily biblical reflections",
      "Practical life applications",
      "Prayer prompts and guidance",
      "Beautiful mountain & floral designs",
      "Supports ongoing transformation"
    ],
    pricing: "Always FREE",
    delivery: "Email subscription + PDF download",
    highlight: "Forever Free"
  },
  {
    id: 6,
    title: "Featured Book",
    description: "Discover practical wisdom and spiritual insights through our featured publication. This book offers biblical guidance for life transformation and spiritual growth, perfect for personal reflection or group study.",
    features: [
      "Biblical wisdom and practical guidance",
      "Personal transformation insights", 
      "Perfect for individual or group study",
      "Spiritual growth and healing",
      "Available in multiple formats",
      "Written from ministry experience"
    ],
    pricing: "Available on Amazon",
    delivery: "Immediate digital or physical delivery",
    highlight: "Ministry Resource",
    bookLink: "https://a.co/d/059Y8gT"
  }
];

export const comingSoonServices = [
  {
    id: 1,
    title: "Bi-Weekly Bible Studies",
    description: "Join our community Bible studies focused on healing, restoration, and growing deeper in God's Word. A safe space to learn, share, and grow together in faith.",
    features: [
      "Community-focused learning",
      "Safe and welcoming environment",
      "Practical Bible application",
      "Fellowship and support",
      "Both in-person and virtual options"
    ],
    timing: "Coming Soon",
    frequency: "Every two weeks"
  },
  {
    id: 2,
    title: "Community Care Pop-Up Shops",
    description: "Free clothing and toiletries for those in need. Because healing includes meeting practical needs with dignity and love - no questions asked, just compassion in action.",
    features: [
      "Gently used clothing (all sizes)",
      "Essential toiletries and hygiene items",
      "No questions asked policy",
      "Dignified shopping experience",
      "Family-friendly environment"
    ],
    timing: "Coming Soon",
    frequency: "Monthly pop-up events"
  }
];

export const aboutContent = {
  vision: "To see individuals restored and rebuilt spiritually, emotionally, and practically; so that they become strong, steadfast, and deeply rooted in Christ, empowered to endure any storm.",
  values: [
    {
      title: "Christ-Centered Foundation",
      description: "Everything we do is rooted in Jesus Christ and biblical truth."
    },
    {
      title: "Healing and Restoration",
      description: "We believe in God's power to heal and restore what has been broken."
    },
    {
      title: "Compassionate Community",
      description: "Walking alongside others with love, grace, and understanding."
    },
    {
      title: "Biblical Truth",
      description: "Preserving and sharing God's truth in a way that draws others to Jesus."
    }
  ]
};

export const founderStory = {
  intro: "My journey has been nothing short of interesting. From as far back as I can remember, building community and helping others has been at the top of my to-do list.",
  background: "At different points in my life, I dreamed of becoming a police officer, a firefighter like my dad, a teacher, and so many other things. Looking back, I see the common thread—each of these roles was about serving, protecting, and uplifting others.",
  foundation: "I grew up in a family deeply rooted in God's Word. Church on Sundays was a given, and summers were filled with vacation Bible school after vacation Bible school. One thing my family did well was making sure we knew what it meant to build our lives on the firm foundation of Jesus Christ.",
  struggle: "Even with that foundation, I strayed. I made choices that led me into places I now know could have destroyed me. And yet… BUT GOD. Time and time again, His hand kept me from the disaster that could have been.",
  purpose: "I created KHEsed+ 'Avad because I know what it feels like to be lost, low, and misunderstood. I know what it's like to feel unseen and question if your life even matters. If that's where you are right now, hear me—it does matter. You matter. And if you're reading this, it's proof that God still has a plan for you, a purpose for you to fulfill. So, keep walking. Keep going. Keep praying.",
  refinement: "Refinement isn't easy. It's uncomfortable, stretching, and sometimes painful. But like gold in the fire, the beauty and brilliance on the other side are worth every moment of the process.",
  joy: "When you see me, and you wonder where the joy comes from. I want you to know the joy of the Lord is my strength, and it is yours too.",
  blessing: "Go in Peace. Be blessed."
};

export const devotionals = {
  mountainVersion: "https://customer-assets.emergentagent.com/job_faith-coaching/artifacts/strz0kln_Khesed%2B%20%27Avad%20Daily%20Devotionals%20Moutain%20version.pdf",
  floralVersion: "https://customer-assets.emergentagent.com/job_faith-coaching/artifacts/dsl16ey6_Khesed%2B%20%27Avad%20Daily%20Devotionals%20Basic%20Flower%20version.pdf"
};

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    text: "Coming soon - we're gathering testimonials from our community members who have experienced God's healing and restoration.",
    role: "Community Member"
  }
];

export const navigationItems = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Spiritual Toolbox", href: "/spiritual-toolbox" },
  { label: "Devotionals", href: "#devotionals" },
  { label: "Donations", href: "#donations" },
  { label: "Contact", href: "#contact" }
];

// Daily devotional content (sample - you can expand this)
export const dailyDevotionals = [
  {
    date: "2024-01-01",
    title: "New Beginnings",
    verse: "\"Therefore, if anyone is in Christ, the new creation has come: The old has gone, the new is here!\" - 2 Corinthians 5:17",
    content: "Today marks not just a new year, but a reminder that in Christ, every day can be a new beginning. God's mercies are new every morning, and His grace is sufficient for whatever lies ahead.",
    prayer: "Lord, thank You for the gift of new beginnings. Help me to walk in Your truth today and every day."
  },
  {
    date: "2024-01-02", 
    title: "Standing Firm",
    verse: "\"Be strong and courageous. Do not be afraid; do not be discouraged, for the Lord your God will be with you wherever you go.\" - Joshua 1:9",
    content: "When life feels uncertain, remember that our strength doesn't come from our circumstances, but from the One who never leaves our side.",
    prayer: "Father, when I feel weak, remind me that You are my strength. Help me to stand firm in Your promises."
  }
];